export default function authHeader() {
  const wave_token = JSON.parse(localStorage.getItem('wave_token'));

  if (wave_token) {
	return { token:  wave_token }; 
	
  } else {
    return {};
  }
}